import { TaskName } from '@/common/constants/taskNames.constants';
import { TaskState } from '@schema';
import i18n from '@/common/i18n';
import type { TaskMap } from '@/common/store/modules/tasks/tasksNotificationMapper';

const taskMap: TaskMap = {
  [TaskName.MAAS_ADD_MIGRATIONS_PROCESS]: {
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Creating migration...')
    }),
    [TaskState.SUCCESS]: ({ payload }) => {
      const instancesCount = Array.isArray(payload?.instances) ? payload.instances.length : 0;
      const count = instancesCount || 1;
      return {
        title: i18n.t('Migration created'),
        message: i18n.tc('Migration successfully created|{num} migrations successfully created', count, { num: count })
      };
    },
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Operation failed'),
      message: error || i18n.t('Operation failed')
    })
  }
};

export default taskMap;
